var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 29,
  viewBox: "0 0 42 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-0.000289917 9.38348L4.75373 4.78444L9.42532 0.104248V9.38348H18.9334L18.9334 28.1042H-0.000289917V9.38348ZM22.457 9.38332L27.1301 4.78428L31.8826 0.104086L31.8826 9.38332H41.3906V28.1041L22.457 28.1041L22.457 9.38332Z",
  fill: "black"
})));
export default SvgIconQuote;